export const mapDocumentTypeToLabel: { [key: string]: string } = {
  idCard: "Dowód osobisty",
  driverLicense: "Prawo jazdy",
  passport: "Paszport",
  permanentResidenceCard: "Karta stałego pobytu",
  other: "Inne",
};
